import React from 'react'

interface TrashIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const TrashIcon: React.FC<TrashIconProps> = ({
  color = '#000',
  gradient = false,
  width = 20,
  height = 24,
  alt = 'delete icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 20 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M7.482 0C6.577 0 6 .821 6 1.625V3H2.425C1.132 3 0 3.982 0 5.292v1.333c0 .345.28.625.625.625h.444l1.627 13.827.574-.067-.574.067c.147 1.252 1.231 2.173 2.49 2.173h8.877c1.26 0 2.344-.92 2.491-2.173L18.181 7.25h.444c.345 0 .625-.28.625-.625V5.292C19.25 3.982 18.118 3 16.825 3H13.25V1.625C13.25.821 12.673 0 11.768 0H7.482zM3.937 20.931L2.327 7.25h14.595l-1.61 13.681c-.07.595-.595 1.07-1.249 1.07H5.187c-.654 0-1.18-.475-1.25-1.07zM17.624 6H1.25v-.708c0-.531.48-1.042 1.175-1.042H16.825c.695 0 1.175.51 1.175 1.042V6h-.376zM12 3V1.625a.463.463 0 00-.1-.3c-.054-.062-.102-.075-.132-.075H7.482c-.03 0-.078.013-.131.075a.463.463 0 00-.101.3V3H12zm2.247 6.687a.625.625 0 10-1.244-.124l-1 10a.625.625 0 001.244.124l1-10zM9.625 9c.345 0 .625.28.625.625v10a.625.625 0 11-1.25 0v-10C9 9.28 9.28 9 9.625 9zm-3.378.563a.625.625 0 10-1.244.124l1 10a.625.625 0 101.244-.124l-1-10z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default TrashIcon
